module.exports = __webpack_public_path__ + "img/brightness_1.f83f3991.png";